export default "__VITE_ASSET__DLQIbhBQ__"